import * as _ from 'lodash';

import { getFieldValue } from 'utils/utils';
import { prettifySize } from 'utils/prettify';
import { digitalAssetsSegmentData } from './digital-assets-segment-data';
import { getAssetFileType } from 'shared/digital-assets/digital-asset-helpers';

export const getDamHintsDefaultHTML = (data: any, hintsFields: Array<string>): string => {
  const segmentItems = _.filter(digitalAssetsSegmentData, (item: any) => {
    return _.includes(hintsFields, item.item_name);
  });
  return _.reduce(segmentItems, (memo: any, item: any) => {
    let value = getFieldValue(data, item) || '';
    if (item.item_name === 'filesize') {
      value = prettifySize(value);
    } else if (item.item_name === 'file_type') {
      value = getAssetFileType(data);
    }
    const html = `
      <div class="hints-row">
        <div class="hints-label">
          ${item.title}
        </div>
        <div class="hints-value">
          ${value}
        </div>
      </div>`;
    return memo + html;
  }, '');
};
